export default __webpack_public_path__ + "static/wavyArc_a-9d37bc217680cda8fdc54e1e668be8ff.jpg";